import React from 'react';
import { Layout } from '../../../blocks/web/layout/layout';
import { SubpageHero } from '../subpage-hero/subpage-hero';
import { Container } from '../container/container';
import styles from './affiliate-terms.module.css';
import legalStyles from './legal-document.module.css';

interface LegalDocumentProps {
    document: { title: string; html: string };
}

/** Checked-in, sanitized Zendesk snapshots; no runtime HTML fetching. */
export const LegalDocument: React.FC<LegalDocumentProps> = ({ document }) => (
    <Layout introAppearance="subpage" intro={<SubpageHero title={document.title} visual="help" />}>
        <section className="pb-[8rem] pt-[2.4rem] lg:pb-[12rem]">
            <Container>
                <article
                    lang="cs"
                    className={`${styles.document} ${legalStyles.document}`}
                    aria-label={document.title}
                    // The static snapshot contains only reviewed document markup and safe links.
                    // eslint-disable-next-line react/no-danger
                    dangerouslySetInnerHTML={{ __html: document.html }}
                />
            </Container>
        </section>
    </Layout>
);
